import axios from 'axios'
import global from '@/global/variable.js'

// 获取过磅列表
export function getHistoryList(data) {
  const url = global.requestUrl + '/productLoading/list?limit=' + data.limit + '&page=' + data.page 
              + '&startDate=' + data.startDate + '&endDate=' + data.endDate 
              + '&plateNumber=' + data.plateNumber
  return axios.get(url)
}

// 获取消息推送列表
export function getList(data) {
  const url = global.requestUrl + '/loadingConfig/list'
  return axios.get(url)
}

// 更新消息推送信息
export function updateOne(data) {
  const url = global.requestUrl + '/loadingConfig/update'
  return axios.post(url, data)
}